import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import {
  FaTachometerAlt,
  FaUsers,
  FaBox,
  FaShoppingCart,
  FaFileInvoiceDollar,
  FaChartBar,FaPeopleCarry,
  FaBook,
  FaChevronDown,
  FaChevronUp,
  FaUser,
  FaUserTie,
  FaBalanceScale,
  FaFileInvoice,
  FaFileAlt,
  FaTruck,FaWpforms ,
  FaWarehouse,FaNetworkWired ,FaSellsy ,
  FaChartLine
} from 'react-icons/fa';
import { RiApps2AddFill } from "react-icons/ri";
import { GrUserWorker,GrAnalytics  } from "react-icons/gr";
import { LuNotebookPen } from "react-icons/lu";
import { TbReportAnalytics,TbPresentationAnalytics,TbFileAnalytics,TbDeviceAnalytics } from "react-icons/tb";
import { MdAnalytics } from "react-icons/md";
import { IoMdAnalytics } from "react-icons/io";
import { BiAnalyse } from "react-icons/bi";
import { BsFillFileEarmarkRuledFill } from "react-icons/bs";

import { IoClose, IoMenu,IoAnalyticsSharp  } from 'react-icons/io5';
import Logo from '../Assets/smart-inventory-logo.jpg';

const Sidebar = ({
  isSidebarOpen,
  setIsSidebarOpen,
  isMobileOpen,
  setIsMobileOpen,
  isMobileView,
  closeMobileSidebar
}) => {
  const navigate = useNavigate();
  const [mastersOpen, setMastersOpen] = useState(false);
  const [salesOpen, setSalesOpen] = useState(false);
  const [accountsOpen, setAccountsOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);







  const handleToggle = () => {
    if (isMobileView) {
      setIsMobileOpen(prev => !prev);
    } else {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const handleLogoClick = () => {
    navigate('/dashboard');
    if (isMobileView) closeMobileSidebar();
  };

  const handleLinkClick = () => {
    if (isMobileView) closeMobileSidebar();
  };

  const toggleMasters = () => {
    setMastersOpen(prev => !prev);
  };

  const toggleSales = () => {
    setSalesOpen(prev => !prev);
  };

  const toggleAccounts = () => {
    setAccountsOpen(prev => !prev);
  };

  const toggleReports = () => {
    setReportsOpen(prev => !prev);
  };

  return (
    <>
      {isMobileView && !isMobileOpen && !isSidebarOpen && (
        <button
          className="floating-toggle"
          onClick={() => setIsMobileOpen(true)}
          aria-label="Open sidebar"
        >
          <IoMenu size={22} />
        </button>
      )}

      {isMobileView && isMobileOpen && <div className="overlay" onClick={closeMobileSidebar} />}

      <aside
        className={`sidebar ${
          isMobileView ? (isMobileOpen ? 'show' : 'hidden') : (isSidebarOpen ? 'show' : 'collapsed')
        }`}
      >
        <div className="sidebar-logo">
          {!isMobileView && isSidebarOpen && (
            // <img
            //   className="img"
            //   src={Logo}
            //   alt="Logo"
            //   style={{ cursor: 'pointer' }}
            //   onClick={handleLogoClick}
            // />
            <div>
            <h4 className='mb-0 title1'> Sri Vinayaga Wire</h4>
             <h4 className='text-center title2'>Industries</h4>
           </div>
          )}

          <button
            className="toggle-btn"
            onClick={handleToggle}
            aria-label="Toggle sidebar"
          >
            {isMobileView ? (isMobileOpen ? <IoClose size={22} /> : <IoMenu size={22} />)
              : (isSidebarOpen ? <IoClose size={22} /> : <IoMenu size={22} />)}
          </button>
        </div>

        <ul className="sidebar-menu">
          {/* Dashboard */}
          <li>
            <NavLink to="/home" onClick={handleLinkClick}>
              <FaTachometerAlt className="icon" /><span>Dashboard</span>
            </NavLink>
          </li>

          {/* Masters Dropdown */}
          <li className={`sidebar-item-dropdown ${mastersOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleMasters}
              aria-expanded={mastersOpen}
              aria-controls="masters-submenu"
            >
              <div className="left">
                <RiApps2AddFill size={22} className="icon" />
                <span>Masters</span>
              </div>
              <div className="caret">
                {mastersOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </button>

            <ul id="masters-submenu" className="submenu" aria-hidden={!mastersOpen}>
              <li className="mb-1">
                <NavLink to="/userlist" onClick={handleLinkClick} className="submenu-link">
                  <FaUser size={18} className="icon-sub" /> <span>Customers</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/supplierlist" onClick={handleLinkClick} className="submenu-link">
                  <GrUserWorker size={18} className="icon-sub" /> <span>Suppliers</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/jobworker" onClick={handleLinkClick} className="submenu-link">
                  <FaPeopleCarry size={22} className="icon-sub" /> <span>Job Workers</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/units" onClick={handleLinkClick} className="submenu-link">
                  <FaBalanceScale size={18} className="icon-sub" /> <span>Units</span>
                </NavLink>
              </li>

              <li className="mb-1">
                <NavLink to="/productlist" onClick={handleLinkClick} className="submenu-link">
                  <FaBox  className="icon-sub" /> <span>Products</span>
                </NavLink>
              </li>

            </ul>
          </li>

          {/* Purchases */}
          <li>
            <NavLink to="/purchaselist" onClick={handleLinkClick}>
              <FaShoppingCart className="icon" /><span>Purchases</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/workallotment" onClick={handleLinkClick}>
              <FaNetworkWired  className="icon" /><span>Job Work</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/inhouse" onClick={handleLinkClick}>
              <FaWarehouse className="icon" /><span>In-House Usage</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/orderlist" onClick={handleLinkClick}>
              <FaWpforms className="icon" /><span>Order Form</span>
            </NavLink>
          </li>

          {/* Sales Dropdown */}
          <li className={`sidebar-item-dropdown ${salesOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleSales}
              aria-expanded={salesOpen}
              aria-controls="sales-submenu"
            >
              <div className="left">
                <FaSellsy size={22} className="icon" />
                <span>Sales</span>
              </div>
              <div className="caret">
                {salesOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </button>

            <ul id="sales-submenu" className="submenu" aria-hidden={!salesOpen}>
              {/* <li className="mb-1">
                <NavLink to="/proforma" onClick={handleLinkClick} className="submenu-link">
                  <FaFileAlt className="icon-sub" /> <span>Proforma</span>
                </NavLink>
              </li> */}
              <li className="mb-1">
                <NavLink to="/invoice" onClick={handleLinkClick} className="submenu-link">
                  <FaFileInvoice size={18} className="icon-sub" /> <span>Invoice</span>
                </NavLink>
              </li>
              {/* <li className="mb-1">
                <NavLink to="/quotation" onClick={handleLinkClick} className="submenu-link">
                  <FaFileAlt className="icon-sub" /> <span>Quotations</span>
                </NavLink>
              </li> */}
              <li className="mb-1">
                <NavLink to="/deliverynote" onClick={handleLinkClick} className="submenu-link">
                  <FaTruck size={18} className="icon-sub" /> <span>Delivery Note</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Accounts Dropdown */}
          <li className={`sidebar-item-dropdown ${accountsOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleAccounts}
              aria-expanded={accountsOpen}
              aria-controls="accounts-submenu"
            >
              <div className="left">
                <FaBook className="icon" />
                <span>Account</span>
              </div>
              <div className="caret">
                {accountsOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </button>

            <ul id="accounts-submenu" className="submenu" aria-hidden={!accountsOpen}>
              <li>
                <NavLink to="/daybook" onClick={handleLinkClick} className="submenu-link">
                  <LuNotebookPen size={16} className="icon-sub" /> <span>Day Book</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Reports Dropdown */}
          <li className={`sidebar-item-dropdown ${reportsOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleReports}
              aria-expanded={reportsOpen}
              aria-controls="reports-submenu"
            >
              <div className="left">
                <IoAnalyticsSharp size={22} className="icon" />
                <span>Reports</span>
              </div>
              <div className="caret">
                {reportsOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </button>

            <ul id="reports-submenu" className="submenu" aria-hidden={!reportsOpen}>
              <li className="mb-1">
                <NavLink to="/stockreport" onClick={handleLinkClick} className="submenu-link">
                  <IoMdAnalytics size={18} className="icon-sub" /> <span>Stock Report (Coil)</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/stockreportwire" onClick={handleLinkClick} className="submenu-link">
                  <IoAnalyticsSharp size={18} className="icon-sub" /> <span>Stock Report (Wire)</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/inhousestockreport" onClick={handleLinkClick} className="submenu-link">
                  <MdAnalytics size={20} className="icon-sub" /> <span>In-House Stock Report</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/workallotmentreport" onClick={handleLinkClick} className="submenu-link">
                  <GrAnalytics size={22} className="icon-sub" /> <span>Return Job Work</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/purchasegst" onClick={handleLinkClick} className="submenu-link">
                  <BiAnalyse size={22} className="icon-sub" /> <span>Purchase GST</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/orderstatus" onClick={handleLinkClick} className="submenu-link">
                  <TbDeviceAnalytics size={22} className="icon-sub" /> <span>Order Status</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/salesgst" onClick={handleLinkClick} className="submenu-link">
                  <TbFileAnalytics size={22} className="icon-sub" /> <span>Sales GST</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/customerledger" onClick={handleLinkClick} className="submenu-link">
                  <TbPresentationAnalytics size={22} className="icon-sub" /> <span>Customer Wise Ledger</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/supplierwiseledger" onClick={handleLinkClick} className="submenu-link">
                  <TbReportAnalytics size={22} className="icon-sub" /> <span>Supplier Wise Ledger</span>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink to="/workerledger" onClick={handleLinkClick} className="submenu-link">
                  <BsFillFileEarmarkRuledFill size={18} className="icon-sub" /> <span>Job Work Ledger</span>
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;